export const PORTAL_UNREGISTERED_MERCHANT_MID_PARAM_NAME = 'unregistered_merchant_mid';
